import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {LegalAgentAgreementVo} from '../../common/shared/api/nicolas/vo/LegalAgentAgreementVo.interface';

/**
 * 법정대리인 동의 약관 조회 (만 14세 미만)
 *
 * Origin: pageNicolasApi.getLegalAgentAgreement
 * API: GET /gateway/auth/v5/getagreement/join14
 */
export async function getAuthGetagreementJoin14(
  params?: {
    accessToken?: string;
    appUserId?: number;
  },
  options?: FetcherOptions
): Promise<LegalAgentAgreementVo> {
  const response = await axiosBffFetch(
    '/api/gateway/auth/v5/getagreement/join14',
    {
      method: 'GET',
      params: params
        ? {
            app_user_id: params.appUserId,
            access_token: params.accessToken,
          }
        : undefined,
    },
    options
  );

  return response.data;
}
